/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoRosreestrIcon20Solid = forwardRef('GovKoRosreestrIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 7V1.019A6.501 6.501 0 0 0 4.019 7H10Z" }),
        React.createElement("path", { d: "M11 7V1.019A6.501 6.501 0 0 1 16.981 7H11Z" }),
        React.createElement("path", { d: "M11 8h5.981A6.501 6.501 0 0 1 11 13.981V8Z" }),
        React.createElement("path", { d: "M10 14H4V8h6v6Z" }),
        React.createElement("path", { d: "M4 15v3.5a.5.5 0 0 0 .5.5H5a5.002 5.002 0 0 0 4.9-4H4Z" })));
});
